import { CreateUserCommand, User } from '@era/security-sdk';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const UserResolverActions = createActionGroup({
  source: 'User Resolver',
  events: {
    'Users requested': emptyProps(),
  },
});

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const UserListUIActions = createActionGroup({
  source: 'User List UI',
  events: {
    'User add requested': props<{ user: CreateUserCommand }>(),
  },
});

export const UserListItemUIActions = createActionGroup({
  source: 'User List Item UI',
  events: {
    'User delete requested': props<{ user: User }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const UserApiActions = createActionGroup({
  source: 'User API',
  events: {
    'Users loaded': props<{ users: User[] }>(),
    'Users loaded error': props<{ error: ErrorModel }>(),
    'User added': props<{ user: User }>(),
    'User Added error': props<{ error: ErrorModel }>(),
    'User deleted': props<{ user: User }>(),
    'User deleted error': props<{ error: ErrorModel }>(),
  },
});
